export default __webpack_public_path__ + "static/media/com_auto.faca8e43.png";